'use client';
import { type FC, memo } from 'react';
import type { CreationWithTask, TaskInfo } from '@/app/types';
import { isAudioTask } from '@/app/utils';
import { AudioTaskCard } from './components/AudioTaskCard';
import { VisualTaskCard } from './components/VisualTaskCard';

interface TaskCardProps {
  task: TaskInfo;
  onOpenDetail: (creationId: CreationWithTask) => void;
  scrollToTop?: () => void; //移动端点击做同款后，滚动到顶端
  isTemplates?: boolean;
}

/**
 * 任务卡片组件 - 根据任务类型自动选择对应的卡片组件
 *
 * @description 这是一个智能路由组件，会根据任务类型自动选择：
 * - AudioTaskCard: 处理音频任务 (text2audio)
 * - VideoTaskCard: 处理视频任务 (其他所有类型)
 *
 * @param task - 任务信息
 * @param onOpenDetail - 打开详情回调
 * @param scrollToTop - 滚动到顶部回调（移动端）
 * @param container - 容器引用
 */
export const TaskCard: FC<TaskCardProps> = memo(({ task, onOpenDetail, scrollToTop, isTemplates = false }) => {
  if (isAudioTask(task.type)) {
    return <AudioTaskCard task={task} onOpenDetail={onOpenDetail} scrollToTop={scrollToTop} />;
  }

  return <VisualTaskCard task={task} onOpenDetail={onOpenDetail} scrollToTop={scrollToTop} isTemplates={isTemplates} />;
});

TaskCard.displayName = 'TaskCard';
